import { Map } from "immutable";

import { ACTIONS } from "features/planner/planner.constants";
import { GroupMapper } from "features/planner/planner.mappers";

export default (state = Map(), action) => {
  const { payload, error, type } = action;

  switch (type) {
    case ACTIONS.UPDATE_VIEW_GROUPS_ORDER:
    case ACTIONS.CREATE_VIEW_GROUPS:
    case ACTIONS.GET_VIEW: {
      if (error) return state;

      const { viewGroups } = payload;

      const groups = viewGroups.map(viewGroup => viewGroup.group);

      return Map(
        groups.map(group => [
          group.groupId.toString(),
          GroupMapper.from(group),
        ]),
      );
    }

    case ACTIONS.GET_VIEW_GROUP: {
      if (error) return state;

      const { group } = payload;
      return state.set(group.groupId.toString(), GroupMapper.from(group));
    }

    case ACTIONS.UPDATE_GROUP_FLAG_TYPE: {
      if (error) return state;

      return state.update(action.id.toString(), group =>
        group.set("flagType", action.flagType),
      );
    }

    case ACTIONS.DELETE_GROUP: {
      if (error) return state;

      return state.delete(action.groupId.toString());
    }

    case ACTIONS.GET_GROUP:
    case ACTIONS.EDIT_GROUP:
    case ACTIONS.GROUP_UNDELETE:
    case ACTIONS.CREATE_GROUP: {
      if (action.error) return state;

      return state.set(payload.groupId.toString(), GroupMapper.from(payload));
    }

    case ACTIONS.GET_GROUPS: {
      if (error) return state;

      return state.merge(
        Map(
          payload.map(Group => [
            Group.groupId.toString(),
            GroupMapper.from(Group),
          ]),
        ),
      );
    }

    case ACTIONS.CREATE_COMPANY_GROUP_RELATION: {
      if (error) return state;

      return state.setIn(
        [payload.groupId.toString(), "companyId"],
        payload.companyId,
      );
    }

    default:
      return state;
  }
};
